export function routes($stateProvider) {
  $stateProvider
    .state('app.painel', {
      url: '/painel',
      abstract: true,
      template: '<div ui-view></div>'
    })
    .state('app.painel.list', {
      url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
      title: 'Gestão de Painéis',
      template: require('./directory/directory.view.html'),
      controller: 'PainelListController',
      controllerAs: 'vm',
      role: 'painelRead',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 20,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "asc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.painel.details', {
      url: '/{id}',
      title: 'Painel de Avaliação',
      controller: 'PainelDetailsController',
      controllerAs: 'vm',
      template: require('./details/details.view.html'),
      role: 'painelRead'
    })
  ;
}

routes.$inject = ['$stateProvider'];
